export default __webpack_public_path__ + "static/media/icon_2.6a9c6bee.svg";